@if (store.presentEditCustomLabelDialogSg()) {
  <!-- NOTE: This is not confirmation dialog, but the size fits for confirmation
type. Maybe should be consider renaming 'confirmation' sizing type so that we
are not limited for the usage -->
  <atn-ds-centered-overlay type="confirmation">
    <div class="add-label-overlay">
      <div class="add-label-overlay__header">
        <h6>Label</h6>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelOrCloseBtnClickHandler('close')"
        ></i>
      </div>
      <div class="add-label-overlay__body">
        <atn-ds-text
          (change)="labelChangedHandler($event ?? '')"
          [value]="store.currentCustomLabelSg()"
        />
      </div>
      <div class="add-label-overlay__footer">
        <atn-ds-button
          type="transparent"
          (click)="cancelOrCloseBtnClickHandler('cancel')"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          [disabled]="!store.currentCustomLabelSg()"
          (click)="store.currentCustomLabelSg() && saveBtnClickHandler()"
          >Save</atn-ds-button
        >
      </div>
    </div>
  </atn-ds-centered-overlay>
}
